module.exports = __webpack_public_path__ + "static/card-recreate-dont-f220bf1d613d7d645aad6c14f6a99d09.png";